export function sortBy(list, attribute, direction) {
  if (direction === 'desc') {
    return _.sortBy(list, [attribute]).reverse();
  }
  return _.sortBy(list, [attribute]);
}

export function updateSortedBy(value, sortedBy, sortedByDir) {
  if (sortedBy == value && sortedByDir === 'asc') {
    return {
      sortedBy: value,
      sortedByDir: 'desc'
    }
  } else if (sortedBy == value && sortedByDir === 'desc') {
    return {
      sortedBy: '',
      sortedByDir: ''
    }
  } else {
    return {
      sortedBy: value,
      sortedByDir: 'asc'
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/common/sortByUtils.js
 **/